// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, requiredPassword }) {
  // از localStorage مقدار رمز را می‌خوانیم
  const storedPassword = localStorage.getItem("dropAccessPassword");

  // اگر رمز ذخیره‌شده مطابق رمز مورد نیاز است، اجازه دسترسی بده
  if (storedPassword === requiredPassword) {
    return children;
  } else {
    // در غیر این صورت، ری‌دایرکت به صفحه /drop
    return <Navigate to="/drop" replace />;
  }
}

export default ProtectedRoute;
